<ng-template #templateRef>
  <mat-dialog-content>
    <h2 mat-dialog-title>Pick your promotions
      <span class="text-right">
            <button (click)="showFilters = !showFilters" id="showFilter" mat-icon-button type="button">
                <mat-icon>filter_list</mat-icon>
            </button>
            </span>
    </h2>
    <mat-card appearance="outlined" [hidden]="!showFilters" style="margin-bottom: 50px;">
      <form #filterForm="ngForm" (ngSubmit)="filter(filterForm.value)" name="filterForm">
        <mat-card-title class="filter-title">Filter</mat-card-title>
        <mat-card-content>
          <div class="row">
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Title</mat-label>
                <input matInput name="Title" ngModel>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Delivery From</mat-label>
                <input [matDatepicker]="actionpicker5" [multiple]="true" matInput name="DeliveryFrom" ngModel>
                <mat-datepicker-toggle [for]="actionpicker5" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #actionpicker5></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Delivery until</mat-label>
                <input [matDatepicker]="actionpicker6" [multiple]="true" matInput name="DeliveryUntil"
                       ngModel>
                <mat-datepicker-toggle [for]="actionpicker6" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #actionpicker6></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Start date from</mat-label>
                <input [matDatepicker]="actionpicker1" [multiple]="true" matInput name="StartFrom"
                       ngModel>
                <mat-datepicker-toggle [for]="actionpicker1" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #actionpicker1></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Start date until</mat-label>
                <input [matDatepicker]="actionpicker2" [multiple]="true" matInput name="StartUntil"
                       ngModel>
                <mat-datepicker-toggle [for]="actionpicker2" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #actionpicker2></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>End date from</mat-label>
                <input [matDatepicker]="actionpicker3" [multiple]="true" matInput name="EndFrom"
                       ngModel>
                <mat-datepicker-toggle [for]="actionpicker3" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #actionpicker3></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>End date until</mat-label>
                <input [matDatepicker]="actionpicker4" [multiple]="true" matInput name="EndUntil"
                       ngModel>
                <mat-datepicker-toggle [for]="actionpicker4" matIconSuffix></mat-datepicker-toggle>
                <mat-datepicker #actionpicker4></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <div style="margin: auto">
            <button mat-button>Filter results</button>
            <button mat-button (click)="showFilters = false">Close</button>
          </div>
        </mat-card-actions>
      </form>
    </mat-card>
    <form #editorForm="ngForm" (ngSubmit)="save()" id="articleEditor" name="editRelation">
      <mat-tab-group>
        <mat-tab label="Graphic">
          <div class="row">
            <table class="mat-mdc-table">
              <tr>
                <td>
                  <mat-checkbox (change)="onToggleAll($event)"></mat-checkbox>
                </td>
                <td>Title</td>
                <td>Start</td>
                <td>End</td>
              </tr>
              <tr *ngFor="let promotion of PromotionCodes">
                <td>
                  <mat-checkbox (change)="onToggle($event, promotion)" [checked]="isSelected(promotion)"></mat-checkbox>
                </td>
                <td>
                  {{promotion.Description}}
                </td>
                <td>
                  {{promotion.StartDate | date: 'shortDate'}}
                </td>
                <td>
                  {{promotion.EndDate | date: 'shortDate'}}
                </td>
              </tr>
            </table>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <mat-paginator (page)="pageChange($event);" [length]="filterObject.count"
                             [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="filterObject.limit"></mat-paginator>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Selected ({{Selected.length}})">
          <table class="mat-mdc-table">
            <tr>
              <td>Name</td>
              <td>Code</td>
            </tr>
            <tr *ngFor="let promotion of Selected">
              <td>
                {{promotion.Description}}
              </td>
              <td>
                {{promotion.StartDate | date: 'shortDate'}}
              </td>
              <td>
                {{promotion.EndDate | date: 'shortDate'}}
              </td>
            </tr>
          </table>
        </mat-tab>
      </mat-tab-group>
      <mat-dialog-actions>
        <div class="fill-remaining-space"></div>
        <button mat-button mat-dialog-close mat-raised-button type="button">Close</button>
        <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>

</ng-template>
